import { IoCloseSharp } from "react-icons/io5";
import { FaEquals } from "react-icons/fa";
import Input from "../../../design/Input";
import cleanAndFormatNumber from "./cleanAndFormatNumber";
import { useEffect, useState } from "react";
import { generateInvoice } from "../../../../faetures/fetch";
import Massage from "../../../design/Massage";
import DateSelector from "./DatesSelector";
import "./ModalCreateTickets.css";


function AccountInDocket({ getPriceFromServer, saveAndSendToServer, setOpenMain, dataAccount, inputEmailPhone,
    setEmail, setPhone, saveOrPay, setSaveOrPay, setMassage, agreeToContinue, textSavePay, senDetailsToInvoice, deleteAufa, sendDetailsToTickets, setTicketAction }) {

    const [showMessage, setShowMessage] = useState(false);
    const [messageText, setMessageText] = useState('');
    const [showDateSelector, setShowDateSelector] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false)
    const [showTicketModal, setShowTicketModal] = useState(false); // Add state for modal visibility


    useEffect(() => {
        const admin = sessionStorage.getItem('admin') === 'admin';
        setIsAdmin(admin);
    }, [])



    const getDatesAndSendDetails = (dates) => {
        // console.log("dates", dates);
        if (dates) {
            // console.log("there is dates");
            senDetailsToInvoice(dates);
        }
        else {
            // console.log("there is no dates");
            senDetailsToInvoice();
        }
    }

    const moveToPayment = () => {
        if (!agreeToContinue) {
            setMassage({ open: true, text: "יש ללחוץ על קבל מחיר" });
        } else {
            setSaveOrPay(false);
            setOpenMain();
        }
    }

    const deleteOrder = () => {
        setShowMessage(false);
        // console.log("deleteOrder");
        deleteAufa();
    }

    const askDeleteOrder = () => {
        // console.log("in askDeleteOrder")
        setMessageText("האם אתה בטוח שברצונך למחוק את ההזמנה?");
        // console.log(messageText);
        setShowMessage(true);
        // console.log(showMessage);
    }

    const openTicketModal = () => {
        setShowTicketModal(true);
    };

    
    // Close the ticket modal
    const closeTicketModal = () => {
        setShowTicketModal(false);
    };

    const handleTicketAction = (action) => {
        setTicketAction(action);
        sendDetailsToTickets(action); 
        closeTicketModal();
    };
    


    return (<>

        {showMessage && (
            <div style={{
                position: 'fixed', top: '50%', left: '50%', width: '400px', padding: '20px', transform: 'translate(-50%, -50%)', zIndex: 1000,
            }}>
                <Massage
                    text={messageText.toString()
                        .padStart(7, "0")}
                    buttonAgree={deleteOrder}
                    setClose={() => setShowMessage(false)}
                    style={{ width: '10px', margin: '0 auto' }}
                />
            </div>
        )}

        {showDateSelector && (
            <DateSelector
                sendDetails={getDatesAndSendDetails}
                onClose={() => setShowDateSelector(false)}
            />
        )}

        {/* Ticket Modal */}
        {showTicketModal && (
            <div className="modal-overlay">
                <div className="modal">
                    <h3>כרטיסי טיסה ונסיעה</h3>
                    <button onClick={()=>handleTicketAction("download")}>הורדת תיקיה</button>
                    <button onClick={()=>handleTicketAction("email")}>שליחת מייל ללקוח</button>
                    <button onClick={closeTicketModal}>ביטול</button>
                </div>
            </div>
        )}

        <div className='account-head-inDocket'>
            <p onClick={getPriceFromServer}>קבל מחיר</p>
            <p>
                <span> {dataAccount.sum}$ </span>
                <IoCloseSharp />
                <span> {dataAccount.numOfNames} אנשים </span>
                <FaEquals />
                <span> {dataAccount.sum * dataAccount.numOfNames}$ </span>
            </p>
        </div>

        <div className='aufa-account-docket'>

            <div className='aufa-account-sum'>
                <p>
                    <span>סה"כ חיוב</span>
                    <span className='under_line' style={{ 'color': 'red' }}> {dataAccount.sum * dataAccount.numOfNames}$ </span>
                    <span> סה"כ זיכוי </span>
                    <span className='under_line' style={{ 'color': 'green' }}> {dataAccount.sumInvoices}$ </span>
                    <span>סה"כ</span>
                    <span className='under_line'> {(dataAccount.sum * dataAccount.numOfNames) - dataAccount.sumInvoices}$ </span>
                </p>
            </div>

            <div className='aufa-account-continer-pay'>
                <p onClick={moveToPayment} style={{
                    backgroundColor: saveOrPay ? "rgba(150,100,150,0.0)" : "rgba(0, 65, 90, 0.3)"
                }}>
                    <span>מעבר לתשלום</span>
                    <span>יתרה לתשלום
                        {
                            `${cleanAndFormatNumber((dataAccount.sum * dataAccount.numOfNames) - dataAccount.sumInvoices)}$, לשמירה ${cleanAndFormatNumber(dataAccount.sumToClose)}$`
                        }
                    </span>
                </p>

                <p onClick={() => { textSavePay.allowedToSave ? setSaveOrPay(true) : setSaveOrPay(false) }} style={{
                    backgroundColor: saveOrPay ? "rgba(0, 65, 90, 0.3)" : "rgba(150,100,150,0.0)"
                }}>
                    {textSavePay.save ? textSavePay.save : ''}
                </p>
            </div>

            <div className='aufa-account-email'>
                <p>כל שינוי / עידכון ישלח לאמייל, אחריות הלקוח לבדוק</p>

                <div>
                    <Input
                        textView={'אמייל'}
                        pattern={'email'}
                        myStyle={'input3'}
                        value={inputEmailPhone.email}
                        onChange={setEmail}
                    />
                    <Input
                        textView={'טלפון'}
                        pattern={'phone'}
                        myStyle={'input3'}
                        value={inputEmailPhone.phone}
                        onChange={setPhone}
                    />
                </div>
            </div>

            <p className='aufa-projects-account-confirmation-of-laws'> יש ללחוץ ולאשר את הפרטים</p>
            <div className="buttons-container">
                <p className="save-button" onClick={saveAndSendToServer}> שמירה </p>
                <p className="print-button" onClick={() => { setShowDateSelector(true) }}>הדפס חשבונית</p>
                <p className="print-button" onClick={openTicketModal}>צור כרטיסים</p>
                {isAdmin &&
                    <p className="delete-button" onClick={() => { askDeleteOrder(); console.log("in delete button") }}>מחק הזמנה</p>}
            </div>
        </div>
    </>)
}

export default AccountInDocket;